@if (editMode) {
  <h2 mat-dialog-title i18n>Edit</h2>
} @else {
  <h2 mat-dialog-title i18n>Enter New</h2>
}

<mat-dialog-content class="cond-content">
  <form [formGroup]="conditionForm" class="cond-form">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cond-expression">
      <mat-label i18n>Expression</mat-label>
      <input
        matInput
        formControlName="expression"
        [errorStateMatcher]="expressionErrorMatcher"
        (input)="onExpressionInput()"
      />
      @if (conditionForm.controls.expression.errors?.expressionSyntax; as expressionErrors) {
        <mat-error>
          @for (msg of expressionErrors; track msg) {
            <div>{{ msg }}</div>
          }
        </mat-error>
      } @else if (expressionWarnings(); as exprWarnings) {
        @if (exprWarnings.length > 0) {
          <mat-hint class="cond-expr-warning">
            @for (msg of exprWarnings; track msg) {
              <div>{{ msg }}</div>
            }
          </mat-hint>
        }
      }
    </mat-form-field>

    <mat-checkbox formControlName="oneArgument" (change)="onOneArgChange($event)" i18n>
      One argument
    </mat-checkbox>

    <mat-radio-group class="cond-operator-group" formControlName="operator">
      <mat-radio-button [value]="+TableFieldConditionOp.OR" i18n>OR</mat-radio-button>
      <mat-radio-button [value]="+TableFieldConditionOp.AND" i18n>AND</mat-radio-button>
    </mat-radio-group>

    <div class="cond-args">
      <div formGroupName="argument1" class="cond-arg-box">
        <div class="cond-arg-title" i18n>Argument 1</div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@value">Value</mat-label>
          <input matInput type="number" step="any" formControlName="value" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@argumentOpertaop">operator</mat-label>
          <mat-select formControlName="operator">
            @for (type of TableFiledConditionOpMap | keyvalue; track type) {
              <mat-option [value]="+type.key">{{ type.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div
        formGroupName="argument2"
        class="cond-arg-box"
        [class.cond-arg-box--disabled]="conditionForm.controls.oneArgument.value"
      >
        <div class="cond-arg-title" i18n>Argument 2</div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@value">Value</mat-label>
          <input
            [readonly]="conditionForm.controls.oneArgument.value"
            matInput
            type="number"
            step="any"
            formControlName="value"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@argumentOpertaop">operator</mat-label>
          <mat-select formControlName="operator">
            @for (type of TableFiledConditionOpMap | keyvalue; track type) {
              <mat-option [value]="+type.key">{{ type.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="cond-results">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n>True Result</mat-label>
        <input matInput formControlName="resultTrue" />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n>False Result</mat-label>
        <input matInput formControlName="resultFalse" />
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
    Close
  </button>
  <button
    matButton="elevated"
    color="accent"
    (click)="onSave()"
    [disabled]="!conditionForm.valid || conditionForm.pristine"
    i18n="@@buttonSave"
  >
    Save
  </button>
</mat-dialog-actions>
